import * as React from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import { SVG } from '@pareto-engineering/design-system'

import { Point } from './common'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'interactive-map'

/**
 * This is the component description.
 */
const InteractiveMap = ({
  id,
  className:userClassName,
  style,
  color,
  locations,
}) => (
  <div
    id={id}
    className={[
      baseClassName,
      componentClassName,
      userClassName,
      `x-${color}`,
    ]
      .filter((e) => e)
      .join(' ')}
    style={style}
  >

    <SVG
      className="x-metadata c-x"
      sprite="/interactive-map.sprite.svg"
      target="map"
      viewBox="0 0 1368 663"
      width="100%"
    />
    {
      locations?.map((location) => (
        <Point
          top={location.top}
          left={location.left}
          location={location.location}
        />
      ))
    }
  </div>
)

InteractiveMap.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   * The color of the map
   */
  color:PropTypes.string,

  /**
   * The locations to display
   */
  locations:PropTypes.arrayOf(
    PropTypes.shape({
      top     :PropTypes.string,
      left    :PropTypes.string,
      location:PropTypes.string,
    }),
  ),
}

InteractiveMap.defaultProps = {
  color:'main',
}

export default InteractiveMap
